@for (dw of deliveryWindows(); track dw) {
  <div>
    <small>{{ dw.category }}</small>
    <p>{{ dw.date | luxonDate }}</p>
    <hr>
  </div>
}

<div>
  <small>Strecke & Parcel</small>
  <p>Bitte beachten Sie, dass die mit „Strecke” gekennzeichneten Artikel nicht über Lekkerland ausgeliefert werden, sondern direkt vom Hersteller/Lieferanten.</p>
  <hr>
</div>
